export const GET_loading = ({ loading }) => loading
